export const environment = {
  version: 'feature-candidate-platform',
  buildDate: '202610201440',
  environment: 'feature-candidate-platform',
  release: 'a0cc67a5f70a02e47dd012605dd5a2f828d12baa',
  production: false,
  debug: true,
  baseUrl: 'https://feature-candidate-platform.leads.catch-talents.dev',
  apiUrl: 'https://feature-candidate-platform.api.catch-talents.dev',
  apiUrlFallback: 'https://develop.api.catch-talents.dev',
  companyBaseUrl: 'https://feature-candidate-platform.company-tool.catch-talents.dev',
  jobboardBaseUrl: 'https://feature-candidate-platform.jobboard.catch-talents.dev',
};
